import { Button } from "@/components/ui/button/button";
import {
	InputOTP,
	InputOTPGroup,
	InputOTPSlot,
} from "@/components/ui/input-otp";
import { getHelpCenterUrl } from "@/lib/utils";
import { useState } from "react";

const otpSlots = [0, 1, 2, 3, 4, 5];

type SignInTwoFactorPageProps = {
	resendCountdown: number;
	isResending: boolean;
	isSubmitting: boolean;
	onResendCode: () => void;
	onSubmit: (otpCode: string) => void;
};

const SignInTwoFactorPage = ({
	resendCountdown,
	isResending,
	isSubmitting,
	onResendCode,
	onSubmit,
}: SignInTwoFactorPageProps) => {
	const [otpCode, setOtpCode] = useState("");

	return (
		<main className="flex min-h-[100dvh] w-full max-w-[800px] flex-col bg-white px-6 py-10 mx-auto">
			<div className="flex flex-1 flex-col items-center justify-start sm:justify-center">
				<div className="flex w-full max-w-md flex-col items-center">
					<div className=" text-center">
						<h1 className="mb-3 text-3xl font-bold text-textDark">
							Two-factor authentication
						</h1>
						<p className="mx-auto max-w-sm text-md leading-6 text-textDark">
							Enter the 6-digit verification code sent to your phone number.
						</p>
					</div>

					<div className="mt-10">
						<InputOTP
							maxLength={6}
							value={otpCode}
							onChange={setOtpCode}
							aria-label="Six-digit verification code"
						>
							<InputOTPGroup className="gap-2 sm:gap-3">
								{otpSlots.map((index) => (
									<InputOTPSlot
										key={index}
										index={index}
										className="h-12 w-11 rounded-xl text-lg font-semibold sm:h-14 sm:w-12"
									/>
								))}
							</InputOTPGroup>
						</InputOTP>
					</div>

					<Button
						type="button"
						className="mt-8 w-full max-w-[312px] text-white"
						disabled={otpCode.length !== 6 || isSubmitting}
						onClick={() => onSubmit(otpCode)}
					>
						{isSubmitting ? "Signing in..." : "Continue"}
					</Button>
				</div>
			</div>

			<div className="text-center">
				<p className=" text-sm text-textDark">Didn&apos;t receive a code? </p>
				<p className="mb-4 text-sm text-textDark">
					<Button
						type="button"
						variant="link"
						className="h-auto p-0 font-semibold text-primary-600"
						disabled={resendCountdown > 0 || isResending}
						onClick={onResendCode}
					>
						{isResending
							? "Sending code..."
							: resendCountdown > 0
								? `Resend code in ${resendCountdown}s`
								: "Resend code"}
					</Button>
				</p>
				<a
					href={getHelpCenterUrl()}
					target="_blank"
					rel="noopener noreferrer"
					className="text-sm text-textDark"
				>
					Need help? <span className="font-semibold">Contact support</span>
				</a>
			</div>
		</main>
	);
};

export default SignInTwoFactorPage;
